import React from 'react';

import { ReactComponent as WaterIconMagenta } from '../../Shared/svgs/water-ef-magenta.svg';
import { ReactComponent as WaterIconWhite } from '../../Shared/svgs/water-ef-white.svg';

import { ReactComponent as WasteIconMagenta } from '../../Shared/svgs/waste-ef-magenta.svg';
import { ReactComponent as WasteIconWhite } from '../../Shared/svgs/waste-ef-white.svg';

import { ReactComponent as ConnectivityIconMagenta } from '../../Shared/svgs/connectivity-ef-magenta.svg';
import { ReactComponent as ConnectivityIconWhite } from '../../Shared/svgs/connectivity-ef-white.svg';

const ICON_MAP = {
    Water: {
        magenta: WaterIconMagenta,
        white: WaterIconWhite,
    },
    Waste: {
        magenta: WasteIconMagenta,
        white: WasteIconWhite,
    },
    Connectivity: {
        magenta: ConnectivityIconMagenta,
        white: ConnectivityIconWhite,
    },
};

export default function UtilityCard({
    type,
    status,
    manageLink,
    infoLink,
    idSuffix,
    isActive,
    onSelect
}) {
    const Icon = isActive
        ? ICON_MAP[type]?.white
        : ICON_MAP[type]?.magenta;

    const label = status === 'Manage'
        ? 'Manage'
        : status === 'Pending'
            ? 'Pending'
            : 'Find out more';

    const isPending = status === 'Pending';
    const target = status === 'Manage' ? manageLink : infoLink;
    const isExternal = target?.startsWith('http');

    const handleSelect = (e) => {
        if (isPending) return;
        if (e) e.preventDefault();
        if (onSelect) onSelect(type);
    };

    const cardClassName = `utility-card legacy-style ${isActive ? 'utility-card--active' : ''}`;

    return (
        <article className={cardClassName} id={`card-${idSuffix}`}>
            <div className="legacy-card-header">
                <Icon className="legacy-card-icon" />
                <h3>{type}</h3>
            </div>
            <div className="legacy-card-divider" />
            {target ? (
                isExternal ? (
                    <a
                        href={target}
                        className="legacy-card-link"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {label} <span aria-hidden="true">›</span>
                    </a>
                ) : (
                    <button
                        type="button"
                        aria-disabled={isPending}
                        className="legacy-card-link"
                        onClick={handleSelect}
                    >
                        {label} <span aria-hidden="true">›</span>
                    </button>
                )
            ) : (
                <span className="legacy-card-link" aria-disabled="true">{label}</span>
            )}
        </article>
    );
}